export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_ACTIVATION_SUCCESS = "AUTH_ACTIVATION_SUCCESS";
export const AUTH_SIGNIN_SUCCESS = "AUTH_SIGNIN_SUCCESS";
export const AUTH_PASSWORD_RESET = "AUTH_PASSWORD_RESET";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_DECONNECT = "AUTH_DECONNECT";
export const USERS_START = "USERS_START";
export const USERS_ERROR = "USERS_ERROR";
export const USERS_ONLINE_SUCCESS = "USERS_ONLINE_SUCCESS";
export const USER_CONNECT_INFO = "USER_CONNECT_INFO";
